import React, { useId } from "react";
import { validEmail } from "../../_shared/commonFunction";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";

const InputComponent = (props) => {
  // Every instance previously shared the hardcoded id "outlined-basic", which
  // broke the <label for="outlined-basic"> ↔ input association (and aria-labelledby)
  // whenever two+ InputComponents render on the same page — a WCAG 4.1.2/1.3.1
  // violation (axe: duplicate-id-aria). useId keeps it unique per instance.
  const autoId = useId();
  const inputId = props?.id || `input-${props?.name || "field"}-${autoId}`;
  const inputColor = props?.color
    ? props.color
    : props?.theme === "primary"
    ? "white"
    : "#332876";

  const handleChange = (ev) => {
    const { value } = ev.target;
    const { name } = props;
    if (
      ((props?.maxLength && Number(props?.maxLength) >= value.length) ||
        !props?.maxLength) &&
      props?.handleCallback
    ) {
      const caret = ev.target.selectionStart;
      const element = ev.target;
      let flag;

      if (props?.onlyNumber) {
        const regex = /^[0-9]+$/;
        if (regex.test(value) || value === "") {
          // setInputValue(value);// eslint-disable-next-line
          // eslint-disable-next-line
          props?.handleCallback(value);
        }
        return;
      }

      if (name === "phone") {
        const regex = /^[0-9\b]+$/;
        if (regex.test(value) || value === "") {
          // setInputValue(value);
          // eslint-disable-next-line
          props?.handleCallback(value);
        }
      } else if (name === "email") {
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        flag = !value.match(mailformat);
        props?.handleCallback(value, flag);
      } else if (props?.capsValue) {
        // eslint-disable-next-line
        props?.handleCallback(value.toUpperCase());
      } else {
        // setInputValue(value);
        // eslint-disable-next-line
        props?.handleCallback(value);
      }
    }
  };
  // return (
  //   <div className="input-wrapper">
  //     <label htmlFor="textBox" className={`input-label ${props?.theme}`}>
  //       {props?.label}
  //     </label>
  //     <input
  //       name={props?.name}
  //       type={props?.type}
  //       className={`input-box ${props?.theme} ${props?.label === "Post Code" ? "text-uppercase" : ""
  //         }`}
  //       placeholder={props?.placeholder}
  //       maxLength={props?.maxLength ? props?.maxLength : null}
  //       disabled={props?.disabled}
  //       value={props?.value ? props?.value : ""}
  //       autoComplete={props?.autoComplete ? props?.autoComplete : null}
  //       onChange={(ev) => handleChange(ev)}
  //     />
  //   </div>
  // );
  return (
    <>
    <Tooltip title={props?.tooltip || ""} arrow>
      <TextField
        id={inputId}
        label={props?.label}
        variant="outlined"
        fullWidth
        name={props?.name}
        type={props?.type}
        className={`input-box ${props?.theme}`}
        placeholder={props?.placeholder}
        disabled={props?.disabled}
        // value={props?.value ? props?.value : ""}
        value={
          props.value !== undefined && props.value !== null ? props.value : ""
        }
        autoComplete={props?.autoComplete ? props?.autoComplete : null}
        onChange={(ev) => handleChange(ev)}
        onFocus={props?.onFocus}
        onBlur={props?.onBlur}
        sx={{
          ...(props?.disabled && {
            cursor: 'not-allowed',
          }),
          "& .MuiOutlinedInput-input": {
            // Override the legacy global `.MuiOutlinedInput-input` rule, which
            // forces every MUI field to white and hides values on white forms.
            color: `${inputColor} !important`,
            WebkitTextFillColor: `${inputColor} !important`,
            ...(props?.disabled && { cursor: 'not-allowed' }),
          },
          ".MuiInputLabel-root": {
            color: inputColor,
          },
        }}
        slotProps={{
          inputLabel: {
            style: {
              color: inputColor,
              paddingBottom: props?.theme === "primary" ? "0" : "1px",
            },
          },
          htmlInput: {
            className: props?.className || "",
            maxLength: props?.maxLength || undefined,
            min: props?.min || undefined,
            max: props?.max || undefined,
            autoCorrect: props?.autoCorrect,
            autoCapitalize: props?.autoCapitalize,
            spellCheck: props?.spellCheck,
          },
        }}
        multiline={props?.multiline || false}
        rows={props?.rows || 1}
      />
    </Tooltip>
    </>
  );
};

export default InputComponent;